<template>
  <div id="layout">
    <div id="main">
      <div
        class="content"
        style="margin-bottom: 10px"
      >
        <div
          class="header pure-g"
          style="padding-left: 10%"
        >
          <div
            class="pure-u-8-24 logo-header-container"
          >
            <router-link to="/">
              <img
                src="../assets/logo-header.png"
                class="logo-header"
                alt="APKollens logga, en tecknad orange apa som dricker öl"
              >
            </router-link>
          </div>
          <div
            class="pure-u-16-24"
            style="text-align: left; margin-top: auto; margin-left: auto;"
          >
            <h1 class="page-header">
              Om oss
            </h1>
            <h2 class="page-subheader">
              <i>"Vad är skillnaden mellan oss och alkoholister? Vi har stolta föräldrar"</i>
            </h2>
            <h2 style="font-size: min(3.0vw, 175%); text-align: right; margin-right: 15%; margin-top: -0.4em">
              - Gammalt studentordspråk
            </h2>
          </div>
        </div>
      </div>
      <div
        class="content"
        style="text-align: left;"
      >
        <h2 class="content-subhead">
          Vad är APKollen.se?
        </h2>
        <p>Det går sedan länge att via olika hemsidor, som använder sig av Systembolagets API, att ranka sortimentet utifrån mlAPK (milliliter Alkohol Per Krona). Idén till APKollen.se kom under en studentfest i Lund våren 2020 (före apokalypsen), och idén var enkel: Att sammanställa samma information om Bordershoppens sortiment. Observera att APKollen.se inte på något sätt är affilierad med varken BorderShop eller Scandlines.</p>
        <p>
          APKollen.se är det enklaste och enligt mig bästa sättet att lära sig mer om denna mytomspunna marknadsplats nere på kontinenten! APKollen har just nu {{ nbrOfEntries }} produkter i sin databas, och högst APK har för tillfället <a
            style="color: darkorange;"
            :href="topEntry.url"
          >{{ topEntry.name }}</a> med {{ topEntry.apk.toFixed(2) }} mlAPK.
        </p>
        <p>APKollen listar även ut PPS (Pris Per Shot), efter förslag från en annan fest. PPS beskriver hur mycket man behövt betala för en vanlig shot (4 cl 40%) om all alkohol i produkten kunnats omvandlats till shotform. Detta för att lättare se just hur mycket man sparar. PPS är inte en del av vår API, men beräknas enkelt genom <i>PPS=16/APK</i>.</p>
        <h2 class="content-subhead">
          Hur fungerar det?
        </h2>
        <p>
          Jag är tyvärr ingen hacker som utför kommandorörelser och slinker in bakvägen på servrar. Istället sammanställer hemmabygget till nätspindel <code>bsscraper</code> regelbundet all information om alkoholhaltiga drycker på bordershop.com/se. Denna informationen lagras sedan i vår databas, som utgör grunden i <router-link
            to="/api_info"
            style="color:darkorange"
          >
            vår API
          </router-link>, som vem som helst får använda.
        </p>
        <h2 class="content-subhead">
          Hur fungerar det inte?
        </h2>
        <p>All data som finns tillgänglig APKollen.se bygger på datan som samlas in från Bordershoppens hemsida. Nätspindeln ignorerar automatiskt alla produkter den av någon anledning inte kan få en fullständig bild av; Det kan vara att alkoholinnehåll saknas, att volym inte är specificerad etc. Det finns tyvärr inte mycket jag kan göra för att lägga till dessa produkter i databasen. Det utförs lite sanering av databasen, men särskrivningar från Bordershoppens sida korrigeras ej. APKollen garanterar <i>inte</i> varornas tillgänglighet i butik, och vi sparar ingen data om huruvida en produkt endast finns tillgänglig på en av Bordershoppens försäljningsställen.</p>
        <h2 class="content-subhead">
          Vem jag är
        </h2>
        <p>Jag som har byggt denna hemsidan är en civilingenjörsstudent (E) i Lund som under coronakrisen hade lite för mycket fritid. Tack vare AF Bostäders goda villkor driver jag idag APKollen.se från en server i min garderob, utan extra el- eller bandbreddskostnader.</p>Har du förslag, idéer eller vill bjuda på en cider? <a
          href="mailto:kontakt@apkollen.se"
          style="color:darkorange;"
        >Skicka ett mail!</a>
      </div>
    </div>
  </div>
</template>

<script>
const API_BASE_URL = "https://api.apkollen.se";

export default {
    name: 'About',
    metaInfo: {
      title: "Om oss | APKollen.se",
      meta: [
        { description: "Historien om APKollen.se, hur hemsidan fungerar, och hur vi kan veta vad som verkligen ger mest alkohol per krona." },
      ]
    },
    data: function () {
        return {
            nbrOfEntries: 0,
            topEntry: { url: "", name: "", apk: 0.0 }, // To prevent blocking of page, this needs default data
        }
    },
    created: function () {
        this.getInfo();
        this.getCount();
    },
    methods: {
        getInfo: function () {
            let url = API_BASE_URL;
            let query = JSON.stringify({ maxItems: 1 }) // API sorts by APK by default

            fetch(url, { method: "POST", body: query })
                .then(res => {
                    return res.json();
                })
                .then(res => {
                    return this.topEntry = res[0];
                })
                .catch(err => {
                    console.error(err)
                });
        },
        getCount: function () {
            let url = API_BASE_URL + "/productcount";

            fetch(url)
                .then(res => {
                    return res.json()
                })
                .then(res => {
                    return this.nbrOfEntries = res;
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }
}
</script>>
